/*
 * patient-lp-enrollment (zod)
 */
import { createInsertSchema, createSelectSchema } from "drizzle-zod"
import * as z from "zod"
import { globalCreateExclude, globalUpdateExclude } from "../utils/constants"
import { patientLpEnrollments } from "./patient-lp-enrollment.schema"

/* Select */
export type PatientLpEnrollment = z.infer<typeof selectPatientLpEnrollmentSchema>
export const selectPatientLpEnrollmentSchema = createSelectSchema(patientLpEnrollments)

/* Filters */
export type PatientLpEnrollmentFilters = z.infer<typeof patientLpEnrollmentFiltersSchema>
export const patientLpEnrollmentFiltersSchema = z.object({
	id: z.string().optional(),
	patientId: z.string().optional(),
	producerId: z.string().optional(),
	active: z.boolean().optional(),
})

/* Create */
export const createPatientLpEnrollmentSchema = createInsertSchema(patientLpEnrollments).partial(globalCreateExclude)
export type CreatePatientLpEnrollment = z.infer<typeof createPatientLpEnrollmentSchema>

/* Update */
export const updatePatientLpEnrollmentSchema = createInsertSchema(patientLpEnrollments)
	.omit(globalUpdateExclude)
	.partial()
	.required({ id: true })
export type UpdatePatientLpEnrollment = z.infer<typeof updatePatientLpEnrollmentSchema>
